import { useState, useEffect } from "react";
import { IReview } from "src/domains";
import { queryGetReviewsByServiceToUser } from "src/graphql";

export const useReviewsByOfferToUser = (offerId?: string) => {
  const [reviews, setReviews] = useState<IReview[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    if (offerId) {
      refresh(offerId);
    }
  }, [offerId]);

  const refresh = async (id: string) => {
    setLoading(true);
    setError(undefined);
    try {
      const response = await queryGetReviewsByServiceToUser({
        serviceId: id,
      });
      setReviews(response?.data.getReviewsByServiceToUser?.items || []);
    } catch (e) {
      console.error(e);
      setError(e as Error);
    }
    setLoading(false);
  };

  return [reviews, loading, error] as const;
};
